import { render, staticRenderFns } from "./SectionModal.vue?vue&type=template&id=450cc1f8&scoped=true&"
import script from "./SectionModal.vue?vue&type=script&lang=js&"
export * from "./SectionModal.vue?vue&type=script&lang=js&"
import style0 from "./SectionModal.vue?vue&type=style&index=0&id=450cc1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450cc1f8",
  null
  
)

export default component.exports